<p-toast></p-toast>
<div class="mw-100" style="background-color: white; height: 100%;">
  <app-navbar></app-navbar>
  <div class="container">
    <div class="button">
      <button class="p-button p-component btn" (click)="regresar(deviceUrl, deviceName)">Menu</button>
      <button class="p-button p-component btn" (click)="newListClick(deviceUrl, deviceName)">+ {{ 'NEW_LIST' |
        translate}}</button>
    </div>

    <div *ngIf="!deviceUrl" class="no-device-message">
      <span class="device-badge">
        <i class="pi pi-link"></i> {{ 'SELECT_DEVICE_FIRST' | translate }}
      </span>
    </div>


    <div *ngIf="deviceUrl" class="device-info">
      <span class="device-badge">
        <i class="pi pi-link"></i> {{ 'DEVICE_SELECTED' | translate }}: {{ deviceUrl }}
      </span>
    </div>
    <p-confirmDialog></p-confirmDialog>
    <p-table [value]="contactos" styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '50rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'NAME_LIST_CONTACT' | translate}}</th>
          <th>{{ 'TYPE_LIST_CONTACT' | translate}}</th>
          <th>{{ 'NUMBER_LIST_CONTACT' | translate}}</th>
          <th>{{ 'LAST_UPDATE_LIST_CONTACT' | translate}}</th>
          <th>{{ 'EDIT_LIST_CONTACT' | translate}}</th>
          <th>{{ 'DELETE_LIST_CONTACT' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-contact of contactos>
        <tr>
          <td>{{ contact.nombre }}</td>
          <td>{{contact.tipoLista}}</td>
          <td>
            <ng-container *ngIf="countNumbersStr(contact.lista) <= contactThreshold; else many">
              {{ previewStr(contact.lista, 12) }}
            </ng-container>

            <ng-template #many>
              <span class="preview">
                {{ previewNoCount(contact.lista, 8) }}
              </span>

              <!-- Botón  -->
              <button type="button" class="ver-mas-btn" (click)="openNumbersModal(contact.nombre, contact.lista)">
                Ver más
              </button>


            </ng-template>
          </td>


          <td>{{contact.updated_at | date: 'dd/MM/YYYY'}}</td>
          <td><i class="pi pi-file-edit icon-table-custom" pTooltip="{{ 'EDIT_CONTACT' | translate}}"
              (click)="modificarLista(contact.id, deviceUrl, deviceName)"></i></td>
          <td><i class="pi pi-trash icon-table-custom" pTooltip="{{ 'DELETE_CONTACT' | translate}}"
              (click)="confirmarEliminar(contact.id)"></i></td>
        </tr>
      </ng-template>
    </p-table>
    <p-dialog [(visible)]="showDialog" [modal]="true" [dismissableMask]="true" [draggable]="false" [resizable]="false"
      [breakpoints]="{ '960px': '92vw', '640px': '96vw' }" styleClass="contacts-modal skinny"
      [header]="selectedContactName || 'Contactos'">

      <div class="contacts-body">
        <ul class="numbers">
          <li *ngFor="let num of allNumbers; trackBy: trackByIndex">
            <span>{{ num }}</span>
          </li>
        </ul>
      </div>
    </p-dialog>


    <div class="text-center mt-3" *ngIf="!contactos || contactos.length === 0">
      <p class="vacio">{{ 'TABLE_EMPTY' | translate}}</p>
    </div>
  </div>
</div>